import React from 'react';
import { formatInStoreTimezone } from '../../utils/dateUtils';

const TransferDetailsModal = ({ transfer, timezone, loading, error, onClose }) => {
  const renderValue = (value) => (value === undefined || value === null || value === '' ? '—' : value);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
        <div className="flex items-start justify-between gap-3 mb-4">
          <h2 className="min-w-0 break-words text-2xl font-bold text-gray-800">Transfer Details</h2>
          <button
            type="button"
            onClick={onClose}
            className="min-h-11 shrink-0 px-3 py-1 text-sm rounded-md bg-gray-100 text-gray-700 hover:bg-gray-200"
          >
            Close
          </button>
        </div>

        {loading && <p className="text-gray-600">Loading transfer details...</p>}
        {error && <p className="bg-red-100 text-red-700 p-3 rounded mb-3">{error}</p>}

        {!loading && !error && transfer && (
          <div className="space-y-5">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
              <div>
                <p className="text-gray-500">Transfer ID</p>
                <p className="font-mono font-semibold text-gray-900">{renderValue(transfer.transferId)}</p>
              </div>
              <div>
                <p className="text-gray-500">Status</p>
                <p className="font-semibold text-gray-900">{renderValue(transfer.status)}</p>
              </div>
              <div>
                <p className="text-gray-500">From Store</p>
                <p className="text-gray-900">{renderValue(transfer.fromStore?.name)}</p>
              </div>
              <div>
                <p className="text-gray-500">To Store</p>
                <p className="text-gray-900">{renderValue(transfer.toStore?.name)}</p>
              </div>
              <div>
                <p className="text-gray-500">Created By</p>
                <p className="text-gray-900">{renderValue(transfer.createdBy?.name)}</p>
              </div>
              <div>
                <p className="text-gray-500">Created At</p>
                <p className="text-gray-900">
                  {transfer.createdAt
                    ? formatInStoreTimezone(transfer.createdAt, 'dd-MM-yyyy HH:mm', timezone)
                    : '—'}
                </p>
              </div>
              <div>
                <p className="text-gray-500">Shipped By</p>
                <p className="text-gray-900">{renderValue(transfer.shippedBy?.name)}</p>
              </div>
              <div>
                <p className="text-gray-500">Shipped At</p>
                <p className="text-gray-900">
                  {transfer.shippedAt
                    ? formatInStoreTimezone(transfer.shippedAt, 'dd-MM-yyyy HH:mm', timezone)
                    : '—'}
                </p>
              </div>
              <div>
                <p className="text-gray-500">Completed By</p>
                <p className="text-gray-900">{renderValue(transfer.completedBy?.name)}</p>
              </div>
              <div>
                <p className="text-gray-500">Completed At</p>
                <p className="text-gray-900">
                  {transfer.completedAt
                    ? formatInStoreTimezone(transfer.completedAt, 'dd-MM-yyyy HH:mm', timezone)
                    : '—'}
                </p>
              </div>
            </div>

            <div>
              <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-600 mb-2">Items</h3>
              <div className="overflow-x-auto border rounded-md">
                <table className="min-w-full text-sm">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-3 py-2 text-left">Product</th>
                      <th className="px-3 py-2 text-left">SKU</th>
                      <th className="px-3 py-2 text-left">Barcode</th>
                      <th className="px-3 py-2 text-right">Shipped</th>
                      <th className="px-3 py-2 text-right">Received</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y">
                    {(transfer.items || []).map((item, index) => (
                      <tr key={`${item.product?._id || item.product || item.name || 'line'}-${index}`}>
                        <td className="px-3 py-2">{renderValue(item.product?.name || item.name)}</td>
                        <td className="px-3 py-2">{renderValue(item.product?.sku)}</td>
                        <td className="px-3 py-2">{renderValue(item.product?.barcode)}</td>
                        <td className="px-3 py-2 text-right">{renderValue(item.quantityShipped)}</td>
                        <td className="px-3 py-2 text-right">{renderValue(item.quantityReceived)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="space-y-2 text-sm">
              <div>
                <p className="text-gray-500">Notes</p>
                <p className="text-gray-900 whitespace-pre-wrap">{renderValue(transfer.notes)}</p>
              </div>
              <div>
                <p className="text-gray-500">Discrepancy Notes</p>
                <p className="text-gray-900 whitespace-pre-wrap">{renderValue(transfer.discrepancyNotes)}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TransferDetailsModal;
